/**
 * 퍼센트 값을 픽셀 값으로 변환하는 함수
 * @param percent 퍼센트 값 (예: '50%')
 * @param base 기준이 되는 픽셀 값
 * @returns 변환된 픽셀 값
 */
export const percentToPixel = (percent: string, base: number): number => {
  return (parseFloat(percent) / 100) * base;
};

/**
 * 픽셀 값을 퍼센트로 변환하는 함수
 * @param pixel 픽셀 값
 * @param base 기준이 되는 픽셀 값
 * @returns 변환된 퍼센트 값
 */
export const pixelToPercent = (pixel: number, base: number): string => {
  return `${(pixel / base) * 100}%`;
};
